import React, { Component } from "react";
import { shanehList, densitiesList } from "../../../settings";
import DropDown from "./dropdown";

export default class RugDensities extends Component {
  // this.props.selectedBrands.indexOf(brand.id) !== -1

  constructor(props) {
    super(props);
    this.state = {
      densities: [],
    };
  }

  getDensities = (shanehs) => {
    if (shanehs.length === 0) {
      return densitiesList;
    }

    let densities = [];
    shanehs.forEach((shaneh) => {
      shanehList[shaneh].forEach((density) => {
        if (densities.indexOf(density) === -1) {
          densities.push(density);
        }
      });
    });
    return densities;
  };

  render() {
    return (
      <div style={{ width: "32%" }}>
        <DropDown
          name={this.props.texts.density}
          list={this.getDensities(this.props.selectedShanehs)}
          selected={this.props.selectedDensities}
          engName="densities"
          changeHandler={this.props.changeHandler}
          stepOnboarding={this.props.stepOnboarding}
        />
      </div>
    );
  }
}
